(() => {
  function initSlider(root) {
    if (!root || root.dataset.lpEnable !== "true") return;

    const grid = root.querySelector(".grid");
    const items = [...root.querySelectorAll(".grid__item")];
    if (!grid || items.length < 2) return;

    // Apply settings from data attributes
    const gap = Number(root.dataset.lpGap || 24);
    const padD = Number(root.dataset.lpPaddingDesktop || 40);
    const padM = Number(root.dataset.lpPaddingMobile || 18);
    root.style.setProperty("--lp-gap", `${gap}px`);
    root.style.setProperty("--lp-pad-desktop", `${padD}px`);
    root.style.setProperty("--lp-pad-mobile", `${padM}px`);

    // Use existing dots container if available, otherwise create one
    let dotsWrap = root.querySelector("[data-lp-dots]");
    if (!dotsWrap) {
      dotsWrap = document.createElement("div");
      dotsWrap.className = "lp-dots";
      dotsWrap.setAttribute("data-lp-dots", "");
      root.appendChild(dotsWrap);
    }

    // Clear dots (important for theme editor reload)
    dotsWrap.innerHTML = "";

    function getActiveIndex() {
      const left = grid.scrollLeft;
      let best = 0;
      let bestDist = Infinity;
      items.forEach((it, i) => {
        const dist = Math.abs(it.offsetLeft - left);
        if (dist < bestDist) {
          bestDist = dist;
          best = i;
        }
      });
      return best;
    }

    function setActiveDot(i) {
      dots.forEach((d, idx) => d.classList.toggle("is-active", idx === i));
    }

    function scrollToIndex(i) {
      const target = items[i];
      if (!target) return;
      grid.scrollTo({ left: target.offsetLeft, behavior: "smooth" });
      setActiveDot(i);
      activeIndex = i;
    }

    // Build dots
    const dots = items.map((_, i) => {
      const b = document.createElement("button");
      b.className = "lp-dot";
      b.type = "button";
      b.setAttribute("aria-label", `Go to slide ${i + 1}`);
      b.addEventListener("click", () => scrollToIndex(i));
      dotsWrap.appendChild(b);
      return b;
    });

    // Update active dot on scroll (throttled)
    let raf = null;
    grid.addEventListener("scroll", () => {
      if (raf) cancelAnimationFrame(raf);
      raf = requestAnimationFrame(() => setActiveDot(getActiveIndex()));
    });

    // Initial dot
    let activeIndex = 0;
    setActiveDot(activeIndex);

    // Auto-scroll
    let timer = null;
    const interval = Number(root.dataset.lpInterval || 3500);
    const auto = root.dataset.lpAutoscroll === "true";

    function startAuto() {
      if (!auto) return;
      stopAuto();
      timer = setInterval(() => {
        activeIndex = (getActiveIndex() + 1) % items.length;
        scrollToIndex(activeIndex);
      }, interval);
    }

    function stopAuto() {
      if (timer) clearInterval(timer);
      timer = null;
    }

    // Pause on hover / touch
    root.addEventListener("mouseenter", stopAuto);
    root.addEventListener("mouseleave", startAuto);
    root.addEventListener("touchstart", stopAuto, { passive: true });
    root.addEventListener("touchend", startAuto, { passive: true });

    startAuto();
  }

  function initAll() {
    document.querySelectorAll(".lp-collection-slider").forEach(initSlider);
  }

  // Shopify theme editor support
  document.addEventListener("shopify:section:load", initAll);
  document.addEventListener("DOMContentLoaded", initAll);
})();
